import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '../../../common/layout/loading.service'
import { NsValidators } from '../../../common/shared/ns-validators'
import { UserAccountsService } from '../../../common/user-accounts/user-accounts.service';
import { UserService } from '../../../core/services/user.service';
import { FormSupportService } from '../../../core/services/form-support.service';
import { HeadlessView } from '../../../common/shared/components/headless-view';
import { LayoutService } from '../../../common/layout/layout.service';
import { MobileDetectorService } from '../../../common/shared/mobile-detector.service';

@Component({
    selector: 'ns-profile-edit',
    templateUrl: './profile-edit.component.html',
    styleUrls: ['./profile-edit.component.scss']
})
export class ProfileEditComponent extends HeadlessView implements OnInit, OnDestroy {

    public subscription: Subscription = new Subscription();

    public user: any;

    public form: FormGroup = this.formBuilder.group({
        phone: ['', NsValidators.simplePhoneValidator],
    });

    constructor(
        protected layoutService: LayoutService,
        protected mobileDetectorService: MobileDetectorService,
        private formBuilder: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userAccountsService: UserAccountsService,
        private userService: UserService,
        private formSupport: FormSupportService,
        private loadingService: LoadingService
    ) {
        super(layoutService, mobileDetectorService);

        this.layoutService.enableFooter();

        this.form.patchValue({
            phone: activatedRoute.snapshot.data.profile?.phone ?? ''
        })
    }

    ngOnInit() {
        this.user = this.userService.user;
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.subscription.unsubscribe();
    }

    onSubmit() {
        this.formSupport.formSubmitHelper(
            this.form,
            this.userAccountsService.editProfile,
            [this.form.getRawValue()]
        ).then(offer => {
            this.loadingService.start()
            this.userService.downloadCurrentUser().subscribe(() => {
                this.loadingService.stop()
                this.router.navigate(['/']);
            })
        }).catch(err => {
        });
    }

}
